// extracted by mini-css-extract-plugin
export default {"detail_view":"detail_detail_view__Fgt82","detail_view_content":"detail_detail_view_content__oYRJu"};